import { Middleware } from '@floating-ui/dom';

/**
 * Custom middleware to positioning select dropdown according to its final position.
 * This is needed because popover reference is complete select (input + label included) so,
 * when it's positioned above, it stays far from input, so when its final position
 * is top (due to flip) changes its `y` position to subtract the label height (20px).
 * This middleware must be positioned at the end of the stack.
 */
export function selectOffset(): Middleware {
  return {
    name: 'select-offset',
    fn({ x, y, placement }) {
      const labelHeight = 20;

      if (placement.includes('top')) {
        y += labelHeight;
      }

      return { x, y };
    },
  }
}
